/* eslint-disable react/prop-types */
import React from 'react';
import { useDispatch } from 'react-redux';
import { removeModal } from 'Redux/modules/modal/actions';
import { Button, Modal } from 'semantic-ui-react';

const ConfirmGoToOnGoingConsult = ({ id, data }) => {
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(removeModal(id));
  };

  const { goToConversation } = data;
  return (
    <Modal open size="tiny">
      <Modal.Header>On-going conversation</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <p>
            You're currently having a consultation with this patient. Would you like to continue the
            existing conversation?
          </p>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button content="Cancel" onClick={onClose} />
        <Button primary content="OK" onClick={goToConversation} />
      </Modal.Actions>
    </Modal>
  );
};

export default ConfirmGoToOnGoingConsult;
